import request from 'app/requests/Quote/Quote.requests'
import {
    RequestKeys,
} from 'app/hooks/useRequest'

import ChangeHistory from 'app/shared-components/ChangeHistory'

export default function AQuoteChangeHistory({
    id,
}: Readonly<{ id: number }>) {
    return (
        <ChangeHistory
            id={id}
            requestKey={RequestKeys.getAQuoteModifications}
            config={request.modifications}
            configName="AQuoteChangeHistoryTable"
            name="AQuoteChangeHistory"
            labelPrefixForChangedColumn={['AccountQuotes']}
        />
    )
}
